import { CountryModel } from "../../pages/shared/models/countryModel";
import { ShippingMethodModel } from "../../pages/shared/models/order/ShippingMethod.model";
import { PaymentStatusModel } from "../../pages/shared/models/order/payment-status.model";
import { PaymentTypeModel } from "../../pages/shared/models/order/payment-type.model";
import { WarehouseModel } from "../../pages/shared/models/order/warehouse.model";
import { AdditionalServiceModel } from "../../pages/shared/models/order/additional-service.model";
import { RecipientDocumentTypeModel } from "../../pages/shared/models/user/recipient/recipient-document-type.model";
import { UserTypeModel } from "../../pages/shared/models/user/user-type.model";
import { User } from "../../pages/shared/models/user/user";
import { OrderModel } from "../../pages/shared/models/order/order-item.model";
import { CityModel } from "../../pages/shared/models/cityModel";
import { ProvinceModel } from "../../pages/shared/models/provinceModel";
import { RegionModel } from "../../pages/shared/models/regionModel";
import { RateResponseModel } from "../../pages/shared/models/api/rate-response.model";

export function handleGetOrderTypes(
  state: StaticDataState,
  payload: any,
): void {
  if (payload) {
    state.orderTypes = payload.orderTypes;
  }
}

export function handleGetOrderStates(
  state: StaticDataState,
  payload: any,
): void {
  if (payload) {
    state.orderStates = payload.orderStates;
  }
}

export function handleGetCountries(state: StaticDataState, payload: any): void {
  if (payload) {
    state.countries = payload.countries;
  }
}

export function handleGetProvinces(state: StaticDataState, payload: any): void {
  if (payload) {
    state.provinces = payload.data;
  }
}

export function handleGetCities(state: StaticDataState, payload: any): void {
  if (payload) {
    state.cities = payload.data;
  }
}

export function handleGetRegions(state: StaticDataState, payload: any): void {
  if (payload) {
    state.regions = payload.data;
  }
}

export function handleGetShippingMethods(
  state: StaticDataState,
  payload: any,
): void {
  if (payload) {
    state.shippingMethods = payload.shippingMethods;
  }
}

export function handleGetWeightUnits(
  state: StaticDataState,
  payload: any,
): void {
  if (payload) {
    state.weightUnits = payload.weightUnits;
  }
}

export function handleGetCurrencies(
  state: StaticDataState,
  payload: any,
): void {
  if (payload) {
    state.currencies = payload.currencies;
  }
}

export function handleGetLanguages(state: StaticDataState, payload: any): void {
  if (payload) {
    state.languages = payload.languages;
  }
}

export function handleGetPaymentStatuses(
  state: StaticDataState,
  payload: any,
): void {
  if (payload) {
    state.paymentStatuses = payload.paymentStatuses;
  }
}

export function handleGetPaymentTypes(
  state: StaticDataState,
  payload: any,
): void {
  if (payload) {
    state.paymentTypes = payload.paymentTypes;
  }
}

export function handleGetWarehouses(
  state: StaticDataState,
  payload: any,
): void {
  if (payload) {
    state.warehouses = payload.warehouses;
  }
}

export function handleGetAdditionalServices(
  state: StaticDataState,
  payload: any,
): void {
  if (payload) {
    state.additionalServices = payload.additionalServices;
  }
}

export function handleGetUserTypes(state: StaticDataState, payload: any): void {
  if (payload) {
    state.userTypes = payload.userTypes;
  }
}

export function handleGetRecipientDocumentTypes(
  state: StaticDataState,
  payload: any,
): void {
  if (payload) {
    state.recipientDocumentTypes = payload.recipientDocumentTypes;
  }
}

export function handleGetProductCategories(
  state: StaticDataState,
  payload: any,
): void {
  if (payload) {
    state.productCategories = payload;
  }
}

export function handleGetProductStores(
  state: StaticDataState,
  payload: any,
): void {
  if (payload) {
    state.productStores = payload.data;
  }
}

export function handleGetCurrentRate(
  state: StaticDataState,
  payload: any,
): void {
  if (payload) {
    state.currentRate = payload;
  }
}

// TODO: for test, should be removed
export function handleRejection(state: StaticDataState, payload: any): void {
  if (payload) {
  }
}

export interface StaticDataState {
  orderTypes: OrderTypeModel[];
  orderStates: OrderStateModel[];
  countries: CountryModel[];
  provinces: ProvinceModel[];
  cities: CityModel[];
  regions: RegionModel[];
  shippingMethods: ShippingMethodModel[];
  weightUnits: WeightUnitModel[];
  currencies: CurrencyModel[];
  languages: LanguageModel[];
  paymentStatuses: PaymentStatusModel[];
  paymentTypes: PaymentTypeModel[];
  warehouses: WarehouseModel[];
  additionalServices: AdditionalServiceModel[];
  userTypes: UserTypeModel[];
  recipientDocumentTypes: RecipientDocumentTypeModel[];
  productTypes: ProductTypeModel[];
  productCategories: ProductCategoryModel[];
  productStores: StoreModel[];
  currentRate: RateResponseModel;
  inWarehouseStateId: number;
}

export interface OrderTypeModel {
  orderTypeId: number;
  name: string;
}

export interface OrderStateModel {
  orderStateId: number;
  name: string;

  isVisibleForWarehouse?: boolean;
  isVisibleForLocalWarehouse?: boolean;
  isVisibleForCustomer?: boolean;
  isDraft?: boolean;
  isFinal?: boolean;
}

export interface WeightUnitModel {
  weightUnitId: number;
  name: string;
}

export interface StoreModel {
  storeId: number;
  name: string;
  isOther: boolean;
  status?: "enabled" | "disabled";
  country: CountryModel;
}

export interface CurrencyModel {
  currencyId: number;
  name: { [key: number]: string };
  sign: string;
}

export interface TransactionTypeModel {
  transactionTypeId: number;
  name: string;
}

export interface TransactionModel {
  transactionHistoryId: number;
  user: User[];
  amount: number;
  currency: CurrencyModel;
  orders: OrderModel[];
  paymentId: string;
  transactionType: TransactionTypeModel;
}

export interface LanguageModel {
  languageId: number;
  name: string;
  abbreviation: string;
}

export interface ProductTypeModel {
  productTypeId: number;
  name: string;
}

export interface ProductCategoryModel {
  productCategoryId: number;
  name: { [key: number]: string };
  description: { [key: number]: string };
  code: string;
  meta_keys?: "string";
}
